

const menuData = [
    {
        id:1001,
        title:"Main",
        menuItems:[
            {
                id:1,
                title:'Dashboard',
                url:"/cpanel/manager/dashboard",
                icon:require('./images/app.svg').default

            },
            {
                id:2,
                title:'Profile',
                url:"profile",
                icon:require('./images/profile.svg').default
            }
        ] 
    },
    {
        id:1002,
        title:"Manage Testimonials",
        menuItems:[
            {
                id:1,
                title:'Testimonials',
                url:"testimonials",
                icon:require('./images/testimony.svg').default

            }
        ] 
    },
    {
        id:1003,
        title:"Manage Users",
        menuItems:[
            {
                id:1,
                title:'Users',
                url:"users",
                icon:require('./images/user-group.svg').default 
            }
        ] 
    },

    {
        id:1003,
        title:"Manage Media",
        menuItems:[
            {
                id:1,
                title:'Galleries',
                url:"galleries",
                icon:require('./images/folder.svg').default,
                galleryItem:[
                    {
                        id:1,
                        title:"All Images",
                        url:"galleries",
                        icon:require('./images/gallery.svg').default
                    },
                    {
                        id:2,
                        title:"Home Images",
                        url:"homeImgs",
                        icon:require('./images/gallery.svg').default
                    }
                ] 
            },
            {
                id:2,
                title:'Videos',
                url:"vclip",
                icon:require('./images/play.svg').default 
            }
        ] 
    }
];


module.exports = menuData;